export default function (ModalService) {
    return function (vehicleId, discrepancy) {
        return ModalService.showModal({
            controller: require('../../controllers/discrepancies/resolve-state/discrepancyResolveState'),
            template: require('../../controllers/discrepancies/resolve-state/discrepancy-resolve-state.html'),
            controllerAs: 'discrepancyResolveState',
            inputs: {
                vehicleId,
                discrepancy
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/discrepancies/openDiscrepancyResolveStateModal.js